import React, { useCallback, useEffect } from "react";

import { Alert, AlertProps, CloseButton } from "@chakra-ui/react";
import { useLocalStorage } from "react-use";
import { compareAsc } from "date-fns";

type TimeboxedAlertProps = React.PropsWithChildren<AlertProps> & {
  noticeId: string;
  viewerCreatedAt: string;
  createdAt: string;
  expireAt: string;
};

const TimeboxedAlert: React.FC<TimeboxedAlertProps> = ({
  noticeId,
  viewerCreatedAt,
  createdAt,
  expireAt,
  children,
  ...alertProps
}) => {
  const [toggle, setToggle] = useLocalStorage(noticeId, true);

  const hide = useCallback(() => {
    setToggle(false);
  }, [setToggle]);

  useEffect(() => {
    if (!toggle) return;
    // The user has been created after the notice was emmited ignore
    // or the expiration date is passed
    if (
      compareAsc(new Date(viewerCreatedAt), new Date(createdAt)) === 1 ||
      compareAsc(new Date(), new Date(expireAt)) === 1
    )
      hide();
  }, [viewerCreatedAt, createdAt, expireAt, hide]);

  // The TimeboxedAlert is disabled
  if (!toggle) return null;

  return (
    <Alert {...alertProps}>
      {children}
      <CloseButton onClick={hide} position="absolute" right="8px" top="8px" />
    </Alert>
  );
};

export default React.memo(TimeboxedAlert);
